(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popup = document.querySelector('.ss-popup');
    if (!popup) return;

    const KEY = 'ss-newsletter-popup';
    let state = {};
    try {
      state = JSON.parse(localStorage.getItem(KEY)) || {};
    } catch (e) {
      state = {};
    }
    const save = () => {
      try {
        localStorage.setItem(KEY, JSON.stringify(state));
      } catch (e) {
        /* noop */
      }
    };

    const open = () => {
      popup.hidden = false;
      requestAnimationFrame(() => popup.classList.add('ss-popup--visible'));
    };

    const close = (persist = true) => {
      popup.classList.remove('ss-popup--visible');
      setTimeout(() => {
        popup.hidden = true;
      }, 350);
      if (persist) {
        state.dismissedAt = Date.now();
        save();
      }
    };

    popup.querySelector('.ss-popup__close')?.addEventListener('click', () => close());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !popup.hidden) close();
    });
    popup.querySelector('form')?.addEventListener('submit', () => {
      try {
        sessionStorage.setItem('ss-popup-submitted', '1');
      } catch (e) {
        /* noop */
      }
    });

    if (popup.hasAttribute('data-design-mode')) {
      document.addEventListener('shopify:section:select', (e) => {
        if (e.target.contains(popup)) open();
      });
      document.addEventListener('shopify:section:deselect', (e) => {
        if (e.target.contains(popup)) close(false);
      });
      return;
    }

    let submittedHere = false;
    try {
      submittedHere = sessionStorage.getItem('ss-popup-submitted') === '1';
      if (submittedHere) sessionStorage.removeItem('ss-popup-submitted');
    } catch (e) {
      /* noop */
    }

    if (popup.querySelector('[data-popup-posted]') && submittedHere) {
      state.subscribed = true;
      save();
      open();
      setTimeout(() => close(false), 4000);
      return;
    }

    if (popup.querySelector('[data-popup-error]') && submittedHere) {
      open();
      return;
    }

    if (state.subscribed) return;

    const reshowMs = (parseInt(popup.dataset.reshowDays, 10) || 30) * 86400000;
    if (state.dismissedAt && Date.now() - state.dismissedAt < reshowMs) return;

    setTimeout(open, parseInt(popup.dataset.delay, 10) || 6000);
  })();

  } catch(e) { console.error(e); }
})();
})();
